import React from 'react';
import { Popover, PopoverContent, PopoverTrigger } from "./popover";
import { Button } from "./button";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem } from "./command";
import { Check, ChevronsUpDown } from "lucide-react";
import { cn } from "../../lib/utils";

const CustomerSelect = ({ customerId, setCustomerId, customers, isDisabled = false }) => {
    const [open, setOpen] = React.useState(false);

    const selectedCustomer = React.useMemo(() => (
        customers.find((c) => (c.id || c._id) === customerId)
    ), [customerId, customers]);

    const displayValue = React.useMemo(() => {
        if (selectedCustomer) {
            const displayName = selectedCustomer.last_name 
                ? `${selectedCustomer.last_name}, ${selectedCustomer.name}` 
                : selectedCustomer.name || 'Unknown';
            return `${displayName}${selectedCustomer.email ? ` (${selectedCustomer.email})` : ''}`;
        }
        return customers.length === 0 ? "Loading customers..." : "Search and select a customer...";
    }, [selectedCustomer, customers]);

    return (
        <Popover open={open} onOpenChange={setOpen}>
            <PopoverTrigger asChild>
                <Button
                    variant="outline"
                    role="combobox"
                    aria-expanded={open}
                    className="w-full justify-between"
                    disabled={isDisabled}
                >
                    <span className="truncate">{displayValue}</span>
                    <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
                </Button>
            </PopoverTrigger>
            <PopoverContent className="w-[600px] p-0" onOpenAutoFocus={(e) => e.preventDefault()}>
                <Command>
                    <CommandInput placeholder="Search customers by name or email..." />
                    <CommandEmpty>No customer found.</CommandEmpty>
                    <CommandGroup className="max-h-[300px] overflow-y-auto">
                        {customers.map((customer) => {
                            const displayName = customer.last_name 
                                ? `${customer.last_name}, ${customer.name}` 
                                : customer.name || 'Unknown';
                            const searchText = `${displayName} ${customer.email || ''} ${customer.phone || ''}`.toLowerCase();
                            const customerId = customer.id || customer._id;
                            
                            return (
                                <CommandItem
                                    key={customerId}
                                    value={searchText}
                                    onSelect={() => {
                                        setCustomerId(customerId);
                                        setOpen(false);
                                    }}
                                >
                                    <Check
                                        className={cn(
                                            "mr-2 h-4 w-4",
                                            customerId === customerId ? "opacity-100" : "opacity-0"
                                        )}
                                    />
                                    <div className="flex flex-col">
                                        <span className="font-medium">{displayName}</span>
                                        {customer.email && <span className="text-sm text-gray-500">{customer.email}</span>}
                                    </div>
                                </CommandItem>
                            );
                        })}
                    </CommandGroup>
                </Command>
            </PopoverContent>
        </Popover>
    );
};

export default CustomerSelect;